import { render, staticRenderFns } from "./ProcessModelManagerment.vue?vue&type=template&id=846bba9a"
import script from "./ProcessModelManagerment.vue?vue&type=script&lang=js"
export * from "./ProcessModelManagerment.vue?vue&type=script&lang=js"
import style0 from "./ProcessModelManagerment.vue?vue&type=style&index=0&id=846bba9a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports